import type { ReactNode, FC } from 'react';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './FormSectionHeading.scss';

interface Props {
  children: ReactNode;
}

const FormSectionHeading: FC<Props> = ({ children }) => {
  return <Heading className={s['root']}>{children}</Heading>;
};

FormSectionHeading.displayName = 'FormSectionHeading';

export default FormSectionHeading;
